export enum FactoryNodeConstantType {
    Number = "Number",
    String = "String",
    Boolean = "Boolean",
}